import Footer from "../Common/Footer";
import Header from "../Common/Header";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../Context/Context";
import { use, useContext, useEffect } from "react";
import { getRecords, PostRecords, getRecords_new } from "../Services/ApiCall";
import FeaturedProperty from "../Common/FeaturedProperties";
import Projects from "../Common/Projects";
import NearByProperties from "../Common/NearByProperties";
import { LoggedInUserID, LoggedInUserName } from "../Services/Urls";
import FilterParams from "../Classes/FilterParams";
import { useNavigate } from "react-router-dom";
import {
  buildFilterString,
  formatDaysAgo,
  formatIndianAmount,
  generate4DigitId,
  formatDate,
  formatTime,
} from "../Services/Helper";
import { useState } from "react";
import { TailSpin } from "react-loader-spinner";
import SidebarFilter from "../Common/SidebarFilter";
import { Drawer } from "@mui/material";
import Conversation from ".././lotties/Conversation.json";
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Lottie from "lottie-react";

import NoData from ".././lotties/NoData.json";
import { sendLandPandaNotification } from "../Services/ApiService";

function Chats() {
  const {
    logindata,

    userData,
  } = useContext(ApiContext);
  // const filters = location?.state?.filters;
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const chatID = params.get("chatID") ?? null;

  const [chatListData, setChatListData] = useState([]);
  const [ChatMsg, setChat] = useState([]);

  const [Msg, setMsg] = useState("");

  const [Loading, setLoading] = useState(true);

  const [searchValue, setSearchValue] = useState("");

  const [selectedChat, setSelectedChat] = useState(null);
  const [pagerState, setPagerState] = useState(1);

  useEffect(() => {
    getChatList();
  }, []);

  const getChatList = () => {
    getRecords(
      414,
      1000,
      `{\$or: [{'UserID': ${LoggedInUserID}}, {'OwnerID': ${LoggedInUserID}}]}`,
      1,
      "",
      (data) => {
        if (data != null) {
          if (data?.hasErrors === false) {
            setChatListData(data?.response?.records || []);

            if (chatID != null) {
              const selected = (data?.response?.records || []).find(
                (chat) => chat?.ChatID.toString() === chatID.toString(),
              );
              setSelectedChat(selected || null);
              if (selected != null) {
                getChatMessages(selected?.ChatID);
              }
            }
            setLoading(false);
          } else {
            console.log("Error in fetching chat list", data);
          }
        }
      },
    );
  };

  const getChatMessages = (chatID) => {
    // setLoading(true);
    getRecords_new(
      415,
      1000,
      `{'ChatID':{\$eq:${chatID}}}`,
      1,
      "",
      1,
      "",
      (data) => {
        if (data != null) {
          if (data?.hasErrors === false) {
            setChat(data?.response?.records || []);
            //  setLoading(false);
          } else {
            console.log("Error in fetching chat messages", data);
          }
        }
      },
    );
  };

  const SendMsg = (text) => {
    let msgbody = [
      {
        ChatID: selectedChat?.ChatID,
        ListingID: selectedChat?.ListingID,
        SenderID: LoggedInUserID,
        SenderName: userData?.User || "User",
        ReceiverID: selectedChat?.OwnerID,
        ReceiverName: selectedChat?.OwnerName || "Owner",
        Msg: Msg == "" ? text : Msg,
        Type: "text",
        Url: "",
      },
    ];

    let updatedChat = {
      ...msgbody[0],
      MsgID: generate4DigitId(),
      cDt: new Date(),
    };
    setChat((prev) => [...prev, updatedChat]);

    setMsg("");

    PostRecords(415, 1, msgbody, (resp) => {
      if (resp != null && resp?.response?.hasErrors === false) {
        // navigate("/chats?chatID=" + res?.response?.response?.clientID);
      } else {
        //  setLoading(false);
      }
    });

    sendLandPandaNotification([
      {
        title: selectedChat?.PropertyTitle,
        coverImage: selectedChat?.CoverImage,
        chatID: selectedChat?.ChatID,
        listingID: selectedChat?.ListingID,
        tabID: selectedChat?.TabID,
        userName:
          selectedChat?.UserID == LoggedInUserID
            ? selectedChat?.OwnerName
            : selectedChat?.UserName,
        OwnerID:
          selectedChat?.UserID != LoggedInUserID
            ? selectedChat?.OwnerID
            : (selectedChat?.UserID ?? 0),
        OwnerName:
          selectedChat?.UserID != LoggedInUserID
            ? selectedChat?.OwnerName
            : (selectedChat?.UserName ?? ""),
        body: Msg,
        appID: 1,
        Price: parseInt(selectedChat?.Price) ?? 0,
        userId:
          selectedChat?.UserID == LoggedInUserID
            ? selectedChat?.OwnerID
            : (selectedChat?.UserID ?? 0),
        parentId: 10027,
      },
    ]);
  };

  let lastDate = "";

  const userId = Number(LoggedInUserID);
  const searchLower = searchValue?.toLowerCase()?.trim() || "";

  const filteredChatList = chatListData?.filter((chat) => {
    const tabFilter =
      pagerState === 2
        ? chat.UserID === userId
        : pagerState === 3
          ? chat.OwnerID === userId
          : true;

    const searchFilter =
      !searchLower ||
      chat?.UserName?.toLowerCase().includes(searchLower) ||
      chat?.OwnerName?.toLowerCase().includes(searchLower);

    return tabFilter && searchFilter;
  });

  const chatChips = [
    "Hi! Is it available?",
    "Okay",
    "Please reply",
    "Not interested",
    "Schedule a visit?",
  ];

  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // console.log("Filters in ViewAllListing:", tabID, filters);
  return (
    <>
      <div className="page-wrapper" style={{ overflow: "hidden" }}>
        <Header />

        <div
          style={{
            height: "88vh",
            display: "flex",
            backgroundColor: chatListData.length !== 0 ? "#f2fff4" : "white",
            fontFamily: "Arial, sans-serif",
          }}
          className="chatbody"
        >
          {chatListData.length !== 0 ? (
            <>
              {/* ================= LEFT CHAT LIST ================= */}
              <div
                style={{
                  width: isMobile ? "100%" : "30%",
                  borderRight: "1px solid #e5e7eb",
                  backgroundColor: "white",
                  display: isMobile
                    ? selectedChat === null
                      ? "block"
                      : "none"
                    : "block",
                }}
              >
                <div style={{ padding: "8px 16px" }}>
                  <input
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    type="text"
                    className="chatsearch"
                    placeholder="Search"
                  />
                </div>

                <div className="chatgrey">
                  {["All", "Buying", "Selling"].map((t, i) => (
                    <span
                      key={i}
                      onClick={() => setPagerState(i + 1)}
                      style={{
                        background:
                          pagerState === i + 1 ? "#16a34a" : "#f3f4f6",
                        color: pagerState === i + 1 ? "#fff" : "#000",
                        padding: "6px 12px",
                        borderRadius: "20px",
                        cursor: "pointer",
                        marginRight: "6px",
                        fontSize: 14,
                      }}
                    >
                      {t}
                    </span>
                  ))}
                </div>

                <div className="chatuserlist">
                  {filteredChatList?.map((chat, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        setSelectedChat(chat);
                        getChatMessages(chat?.ChatID);
                      }}
                      style={{
                        padding: "14px 16px",
                        cursor: "pointer",
                        display: "flex",
                        borderBottom: "1px solid #f0f0f0",
                        backgroundColor:
                          selectedChat?.ChatID === chat?.ChatID
                            ? "#f2fff4"
                            : "white",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="developer">
                        <img src="assets/img/lplogo.jpg" alt="img" />
                      </div>

                      <div style={{ width: "100%" }}>
                        <div
                          style={{
                            fontWeight: "600",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {chat?.UserID == LoggedInUserID
                            ? chat?.OwnerName
                            : chat?.UserName}

                          <small style={{ fontSize: "12px" }}>
                            {formatTime(chat?.cDt)}
                          </small>
                        </div>

                        <div style={{ fontSize: 11, color: "#6b7280" }}>
                          {chat.PropertyTitle}
                        </div>

                        <div
                          style={{
                            fontSize: 13,
                            color: "#6b7280",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>{chat.LastMsg}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* ================= RIGHT CHAT AREA ================= */}
              <div
                style={{
                  flex: 1,
                  display: isMobile
                    ? selectedChat !== null
                      ? "flex"
                      : "none"
                    : "flex",
                  flexDirection: "column",
                  backgroundColor: "#f2fff4",
                  width: "100%",
                }}
              >
                {/* HEADER */}
                {selectedChat && (
                  <div
                    style={{
                      padding: "12px",
                      backgroundColor: "white",
                      borderBottom: "1px solid #e5e7eb",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    {/* BACK BUTTON MOBILE */}
                    {isMobile && (
                      <button
                        onClick={() => setSelectedChat(null)}
                        style={{
                          border: "none",
                          background: "#f3f4f6",
                          borderRadius: "50%",
                          width: "25px",
                          height: "25px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          fontSize: "12px",
                        }}
                      >
                        ←
                      </button>
                    )}

                    <img
                      src={selectedChat?.CoverImage}
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                      }}
                    />

                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 600 }}>
                        {selectedChat?.UserName}
                      </div>
                      <div style={{ fontSize: 13 }}>
                        {selectedChat?.PropertyTitle}
                      </div>
                    </div>

                    <div
                      style={{
                        fontSize: "14px",
                        color: "#16a34a",
                      }}
                    >
                      ₹{formatIndianAmount(parseFloat(selectedChat?.Price))}
                    </div>
                  </div>
                )}

                {/* MESSAGES */}
                <div
                  style={{
                    flex: 1,
                    padding: isMobile ? "10px" : "16px",
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {ChatMsg?.map((msg, i) => (
                    <div
                      key={i}
                      style={{
                        alignSelf:
                          msg.SenderID == LoggedInUserID
                            ? "flex-end"
                            : "flex-start",
                        background:
                          msg.SenderID == LoggedInUserID ? "#059669" : "white",
                        color:
                          msg.SenderID == LoggedInUserID ? "white" : "black",
                        padding: "10px 14px",
                        borderRadius: "18px",
                        maxWidth: isMobile ? "85%" : "70%",
                        fontSize: isMobile ? "13px" : "14px",
                      }}
                    >
                      {msg.Msg}
                    </div>
                  ))}
                </div>

                {/* INPUT */}
                {selectedChat && (
                  <div style={{ padding: 10, background: "white" }}>
                    <div
                      className="chatchipset"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "6px",
                        marginBottom: "8px",
                      }}
                    >
                      {chatChips.map((text, i) => (
                        <span key={i} onClick={() => SendMsg(text)}>
                          {text}
                        </span>
                      ))}
                    </div>

                    <div style={{ display: "flex", gap: "8px" }}>
                      <input
                        value={Msg}
                        onChange={(e) => setMsg(e.target.value)}
                        placeholder="Type..."
                        style={{
                          flex: 1,
                          padding: "10px",
                          borderRadius: "20px",
                          border: "1px solid #ccc",
                          minWidth: 0,
                        }}
                      />

                      <button
                        disabled={!Msg}
                        onClick={SendMsg}
                        style={{
                          background: "#16a34a",
                          color: "white",
                          border: "none",
                          padding: "10px 14px",
                          borderRadius: "20px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Send
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
              <Lottie animationData={NoData} loop />
            </div>
          )}
        </div>
      </div>
      {Loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <TailSpin color="#00BFFF" height={80} width={80} />
        </div>
      )}
    </>
  );
}

export default Chats;
